/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      controller — public RSVP confirm/decline flow for a booked
 *              event, reached via an event_id query param (e.g. from an email link)
 *   extends:   Controller (@ember/controller)
 *   template:  none
 *   qp:        event_id
 *   key:       loadDataTask, sendAnswerTask
 *   uses:      applicationController (@controller('application')); session/
 *              notify/intl/log services; beebee-base/lib/utility
 *              (beebeeAjaxPost/Get, notifyUserError), beebee-base/lib/get-config
 *   siblings:  routes/confirm.js, templates/confirm.hbs
 *   tests:     controllers-logic-test.js, wave17-coverage-test.js
 *
 * Loads the event's confirmation info via /confirm_event, then posts the
 * user's accept/decline answer back to the same endpoint.
 */
import Controller from '@ember/controller';
import { beebeeAjaxPost, beebeeAjaxGet } from 'beebee-base/lib/utility';
import { notifyUserError } from 'beebee-base/lib/utility';
import { set } from '@ember/object';

import { inject as iController } from '@ember/controller';
import { inject as iService } from '@ember/service';
import { task } from 'ember-concurrency';

import getConfig from 'beebee-base/lib/get-config';
export default class ConfirmController extends Controller {
  @iController('application') applicationController;
  @iService session;
  @iService notify;
  @iService intl;
  @iService log;

  queryParams = ['event_id'];
  notFound = false;

  @(task(function* () {
    set(this, 'actionDone', null);
    set(this, 'notFound', null);
    set(this, 'information', null);

    try {
      let event = yield beebeeAjaxGet(`${getConfig(this).APP.urlApi}/confirm_event`, this.session.token, {
        event_id: this.event_id,
      });

      if (event?.information) {
        event.information.alreadyConfirmed = [1000, 1001].includes(
          event.information.event_status_id
        );
        set(this, 'information', event.information);
      } else {
        set(this, 'notFound', true);
      }
    } catch (e) {
      set(this, 'notFound', true);
    }
  }).drop())
  loadDataTask;

  @(task(function* (action = false) {
    try {
      yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/confirm_event`, this.session.token, {
        event_id: this.event_id,
        action: action,
        token: this.session.token,
      });
    } catch (e) {
      this.log.error('sendAnswerTask failed', e);
      notifyUserError(this.notify, e, this.intl);
      return;
    }

    set(this, 'actionDone', {
      action: action,
    });
  }).drop())
  sendAnswerTask;
}
